import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	padding: 29px 12px 34px;
	background: ${({ theme }) => theme.gradient.backgroundProfile};
	border-radius: 8px;
	margin-bottom: 16px;
	display: flex;
	position: relative;
	border: 1px solid ${({ theme }) => theme.colors.control.dark};
	overflow: hidden;
`;

export const Title = styled.h2`
	font-size: 24px;
	line-height: 33px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin: 0;

	@media (max-width: 640px) {
		font-size: 15px;
	}
`;

export const BgImage = styled.img`
	position: absolute;
	top: 0;
	right: 0;

	border-top-right-radius: 8px;
	border-bottom-right-radius: 8px;

	mix-blend-mode: lighten;
	@media (max-width: 1100px) {
		filter: brightness(50%);
	}
`;
